module.exports = __webpack_public_path__ + "img/139-venezuela.3d9347e2.svg";